// Copyright (c) 2018 Deere & Company

import actions from '../../action-list';
import {routerActions} from 'react-router-redux';

export const cancelInvoiceSubmission = () =>
    routerActions.push('/claims/dealer-invoices');

export const updateClaimsProcess = (property, value) => ({
    property,
    type: actions.UPDATE_DEALER_INVOICE_INVOICE_TO_COMPLETE_CLAIMS_PROCESS,
    value
});

export const updateInvoiceToComplete = invoice =>

    dispatch => {

        dispatch({
            invoice,
            type: actions.UPDATE_DEALER_INVOICE_INVOICE_TO_COMPLETE
        });

        invoice.isMassProcessing ?
            dispatch(routerActions.push(`/claims/invoice-details/mass-process-invoice/${invoice.massProcess.invoiceRequestNumber}`)) :
            dispatch(routerActions.push(`/claims/invoice-details/claim-process-invoice/${invoice.claimsProcess.claimNumber}`));

    };

export const updateMassProcess = (property, value) => ({
    property,
    type: actions.UPDATE_DEALER_INVOICE_INVOICE_TO_COMPLETE_MASS_PROCESS,
    value
});



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/action-creators/invoice-to-complete.js